import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=0171a8de&scoped=true"
import script from "./SettingsTab.vue?vue&type=script&lang=js"
export * from "./SettingsTab.vue?vue&type=script&lang=js"
import style0 from "./SettingsTab.vue?vue&type=style&index=0&id=0171a8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171a8de",
  null
  
)

export default component.exports